import { getMessages } from '../../../../../../../../store/constants';

export const MESSAGE_DESCRIPTION = getMessages().getText('board_settings.archive_on_delete.description');
